export default __webpack_public_path__ + "static/skadekompasse-d0c3323725f0c3312b8cb8f2c042453f.svg";